import React from 'react';
import {RoutePermittedRole} from 'shared/constants/AppConst';

const Reports= React.lazy(()=>import('./reports'))
const ReportsHistory = React.lazy(() => import('./ReportsHistory'))
export const ReportConfigs = [
 
    {
        permittedRole: RoutePermittedRole.ALL,
        path: '/master/reports',
        element: <Reports />,
      },
      {
        // Access is governed by the Reports module's "Download And Upload"
        // action, checked inside the page — a role list cannot express that.
        permittedRole: RoutePermittedRole.ALL,
        path: '/master/reports-history',
        element: <ReportsHistory />,
      },
  
];
